const approval = `#pragma version 6
txn ApplicationID
int 0
==
bnz main_l18
txn OnCompletion
int DeleteApplication
==
bnz main_l17
txn OnCompletion
int UpdateApplication
==
bnz main_l16
txn OnCompletion
int CloseOut
==
bnz main_l15
txn OnCompletion
int OptIn
==
bnz main_l14
txna ApplicationArgs 0
byte "donate"
==
bnz main_l11
txna ApplicationArgs 0
byte "claim"
==
bnz main_l10
txna ApplicationArgs 0
byte "appAddressOptin"
==
bnz main_l9
err
main_l9:
global GroupSize
int 3
==
assert
gtxn 0 Sender
byte "Creator"
app_global_get
==
assert
gtxn 0 Receiver
global CurrentApplicationAddress
==
assert
gtxn 0 Amount
int 201000
==
assert
itxn_begin
int axfer
itxn_field TypeEnum
byte "elemID"
app_global_get
itxn_field XferAsset
int 0
itxn_field AssetAmount
global CurrentApplicationAddress
itxn_field AssetReceiver
itxn_submit
gtxn 2 TypeEnum
int axfer
==
assert
gtxn 2 Sender
txn Sender
==
assert
gtxn 2 AssetReceiver
global CurrentApplicationAddress
==
assert
gtxn 2 AssetAmount
byte "Goal"
app_global_get
int 2
*
==
assert
int 1
return
main_l10:
global GroupSize
int 2
==
assert
gtxn 0 TypeEnum
int pay
==
assert
gtxn 0 Sender
byte "Receiver"
app_global_get
==
assert
gtxn 0 Receiver
global CurrentApplicationAddress
==
assert
gtxn 0 Amount
int 1000
==
assert
gtxn 1 Sender
byte "Receiver"
app_global_get
==
assert
global LatestTimestamp
byte "EndDate"
app_global_get
>
assert
byte "elemID"
app_global_get
byte "Total"
app_global_get
callsub assetHandleTxn_0
byte "Total"
int 0
app_global_put
int 1
return
main_l11:
global LatestTimestamp
byte "StartDate"
app_global_get
>=
global LatestTimestamp
byte "EndDate"
app_global_get
<=
&&
assert
gtxn 2 Amount
byte "Total"
app_global_get
+
byte "Goal"
app_global_get
<=
assert
global GroupSize
int 3
==
assert
gtxn 0 TypeEnum
int pay
==
assert
gtxn 0 Receiver
global CurrentApplicationAddress
==
assert
gtxn 0 Amount
int 1000
==
assert
gtxn 2 TypeEnum
int pay
==
assert
gtxn 2 Receiver
global CurrentApplicationAddress
==
assert
byte "Total"
byte "Total"
app_global_get
gtxn 1 Amount
+
app_global_put
int 0
global CurrentApplicationID
byte "MyAmountGiven"
app_local_get_ex
store 1
store 0
load 1
bnz main_l13
main_l12:
int 0
byte "myAmountGiven"
load 0
gtxn 2 Amount
+
app_local_put
byte "elemID"
app_global_get
gtxn 2 Amount
int 2
*
callsub assetHandleTxn_0
int 1
return
main_l13:
int 0
byte "myAmountGiven"
gtxn 2 Amount
app_local_put
b main_l12
main_l14:
global LatestTimestamp
byte "StartDate"
app_global_get
>=
global LatestTimestamp
byte "EndDate"
app_global_get
<=
&&
return
main_l15:
int 1
return
main_l16:
txn Sender
byte "Creator"
app_global_get
==
assert
int 1
return
main_l17:
txn Sender
byte "Creator"
app_global_get
==
return
main_l18:
byte "Creator"
txn Sender
app_global_put
txn NumAppArgs
int 6
==
assert
byte "StartDate"
txna ApplicationArgs 0
btoi
app_global_put
byte "EndDate"
txna ApplicationArgs 1
btoi
app_global_put
byte "Goal"
txna ApplicationArgs 2
btoi
app_global_put
byte "Receiver"
txna ApplicationArgs 3
app_global_put
byte "Total"
int 0
app_global_put
byte "FundCloseDate"
txna ApplicationArgs 4
btoi
app_global_put
byte "elemID"
txna ApplicationArgs 5
btoi
app_global_put
int 1
return

// assetHandleTxn
assetHandleTxn_0:
store 3
store 2
itxn_begin
int axfer
itxn_field TypeEnum
load 2
itxn_field XferAsset
load 3
itxn_field AssetAmount
txn Sender
itxn_field AssetReceiver
itxn_submit
retsub`;

export default approval